module.exports = __webpack_public_path__ + "img/katarina_outside_4.7b7818ef.jpg";